import getCurrencyDisplay from '../../../utils/numeric/getCurrencyDisplay';
import getIntegerDisplay from '../../../utils/numeric/getIntegerDisplay';
import getNumberDisplay from '../../../utils/numeric/getNumberDisplay';
import { isCurrency, getCurrency, isInteger, isNumber } from './isNumeric';
import getNumericStorage from './getNumericStorage';
export default function getNumericDisplay(props, value) {
  var _ref = props || {},
    options = _ref.options;
  var _ref2 = options || {},
    suppressFormatting = _ref2.suppressFormatting;
  if (suppressFormatting) {
    return getNumericStorage(props, value);
  }
  if (isCurrency(props)) {
    return getCurrencyDisplay(value, getCurrency(props));
  }
  if (isInteger(props)) {
    return getIntegerDisplay(value);
  }
  if (isNumber(props)) {
    return getNumberDisplay(value);
  }
  return '';
}